module.exports = __webpack_public_path__ + "static/media/atk-logo.20f163b1.jpg";